import { connect } from 'react-redux';
import { getFaveButtonStateWithDefaults } from '../../../../../../CollectionPanel/redux/selectors';
var mapStateToProps = function (state, ownProps) {
    var _a = ownProps.deviation, deviationId = _a.deviationId, stats = _a.stats;
    var faveCount = getFaveButtonStateWithDefaults(state, deviationId, {
        faveCount: stats && stats.favourites,
    }).faveCount;
    return {
        faveCount: faveCount,
    };
};
export default connect(mapStateToProps);
//# sourceMappingURL=FaveControl.container.js.map